import { render } from "./table-action-button.vue?vue&type=template&id=b4a1b364"
import script from "./table-action-button.vue?vue&type=script&lang=js"
export * from "./table-action-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__